import './ApprovalCard.scss';

interface IApprovalCardProps {
  heading: string;
  iconSrc: any;
  content: string;
}
const ApprovalCard = ({ heading, iconSrc, content }: IApprovalCardProps) => {
  return (
    <div className="approval-card">
      <div className="heading">
        <img src={iconSrc} alt="subscriber-registration" />
        <span>{heading}</span>
      </div>
      <div className="content">{content}</div>
    </div>
  );
};

export default ApprovalCard;
